import axios from 'axios'
import allConstants from './constant'
import { Message } from 'element-ui'
import LeonLoading from '@plugin/LeonLoading'           // loading弹窗
import NoNetwork from '@plugin/NoNetwork'               // 断网弹窗
import LoginRegister from '@plugin/login-register'      // 登录弹窗
import $store from '../../store'
import $utils from '@assets/utils'
import { routerInstance } from '../../router/index'
import Config from '../config'

/** 获取当前路由的 query，使用传统 if 判断避免可选链 */
const getRouterQuery = () => {
  if (routerInstance && routerInstance.currentRoute && routerInstance.currentRoute.query) {
    return routerInstance.currentRoute.query
  }
  return {}
}

// 接口常量启动时一次性加载，路由保持动态加载
const apiConstant = { ...allConstants }

// 任务信息找不到/取消发布：A_0012、45101
// 没有任务权限：A_0013、45118
// 任务未开启：A_0016、45116
// 任务已结束：A_0017、45117
// 体验模式暂不支持操作：A_0040、40940
// 您当前的帐号类型暂不支持进行此操作哦：A_0041、40941
// 你未报名改活动季，无权限访问该任务：A_0050、41008
// 活动季未发布：A_0051、40942

let pending = [] // 声明一个数组用于存储每个请求的取消函数和axios标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      pending[p].f() // 执行取消操作
      pending.splice(p, 1)
    }
  }
}
axios.interceptors.request.use(config => {
  if (config.url === '/api/test/invigilate/getReviewResult') {
    removePending(config)
    config.cancelToken = new CancelToken((c) => {
      // 这里的axios标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      pending.push({ u: config.url + '&' + config.method, f: c })
    })
  }
  axios.defaults.headers.post['lang'] = localStorage.getItem('bloom:lang') && JSON.parse(localStorage.getItem('bloom:lang')) ? JSON.parse(localStorage.getItem('bloom:lang')).data === 'en' ? 'en_US' : 'zh_CN' : ''
  // config.data = JSON.stringify(config.data)
  // config.headers.lang = localStorage.getItem('bloom:lang') === 'en' ? 'en_US' : 'zh_CN'
  return config
})
/**
 * @method 登出函数
 */
const signOut = () => {
  $utils.cache('userData', null)
  $store.commit('set_isLogin', false)
  LoginRegister.install()              // 弹出登录框
}
/**
 * @method 是否有用户信息
 */
const haveUserData = (headers) => {
  // 是否有头部
  let flag = headers['bloom-lg'] || headers['Bloom-lg']
  let userData = JSON.parse($utils.cache('userData'))
  if (flag === '1' && !userData) {
    // 没有用户登录信息 调用getUserInfo USER_INFO 并且需要登录
    post('USER_INFO', {}, (res) => {
      let data = JSON.stringify(res.data)
      $utils.cache('userData', data)
      $store.commit('set_isLogin', true)
    })
  }
}
/** 同步服务端时间
 *
 * @param {string} time
 */
const syncTime = ({ date }) => {
  // time / 2 降低误差
  let timeDifference = new Date(date).getTime() - new Date().getTime()
  let getTimeDifference = $store.state.common.timeDifference
  $store.commit('setDiff', timeDifference) // 服务器和本地的时间差值
  if (timeDifference === getTimeDifference) {
    return
  }
  if (timeDifference || (timeDifference === 0 && getTimeDifference !== 0)) {
    $store.commit('set_timeDifference', timeDifference)
  }
}

// 设置全局的请求次数，请求的间隙
axios.defaults.retry = 3
axios.defaults.retryDelay = 1000
// 配置断网是应该做什么事
axios.interceptors.response.use(res => {
  if (res && res.headers && res.headers['bloom-v']) {
    // 如果缓存存在
    if ($utils.cache('version')) {
      if ($utils.cache('version') !== res.headers['bloom-v']) {
        $utils.cache('version', res.headers['bloom-v'])
        window.location.reload(true)
      }
    } else {
      // 没有缓存
      if (Config.version !== res.headers['bloom-v']) {
        $utils.cache('version', res.headers['bloom-v'])
        window.location.reload(true)
      }
    }
  }
  return res
}, err => {
  var config = err.config
  // 如果配置不存在或未设置重试选项，则拒绝
  if (!config || !config.retry) return Promise.reject(err)
  // 设置变量以跟踪重试计数
  config.__retryCount = config.__retryCount || 0
  // 检查我们是否已到重试总数
  if (config.__retryCount >= config.retry) {
    // 到达次数后返回错误
    // 考试服务index页面其他接口禁止断网提示
    if (routerInstance && routerInstance.currentRoute && routerInstance.currentRoute.path === '/ExamSystemIndex' && (config.url === '/api/pushMessage/unReadCount' || config.url === '/api/pushMessage/unReadAll' || config.url === '/api/common/season/info' || config.url === '/api/common/contest/list' || config.url === '/api/v3/contest/contest/list')) {
      // 不做断网提示
    } else {
      // 这个是断网后的弹窗
      NoNetwork.install()
    }
    return Promise.reject(err)
  }
  // 增加重试次数
  config.__retryCount += 1
  // Create new promise to handle exponential backoff
  var backoff = new Promise((resolve) => {
    let timer = setTimeout(() => {
      clearTimeout(timer)
      resolve()
    }, config.retryDelay || 1)
  })
  // 让axios重新请求
  return backoff.then(() => {
    return axios(config)
  })
})

/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const postNoLoading = async (constant, data = {}, callback, errorCallback, catchCallback) => {
  // 加载loading遮罩
  // LeonLoading.install()
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  // 请求前时间
  // let beforeTime = new Date().getTime()
  // 兼容异步函数
  const apiFn = () => {
    return new Promise((resolve, reject) => {
      axios.post(
        url,
        JSON.stringify(data)
      ).then((res) => {
        // imConnectStatus等于1,且接口是TEST_INV_EXAM_TRANSACTION,则重连im
        if (res && res.data && res.data.data && +res.data.data.imConnectStatus === 1 && constant === 'TEST_INV_EXAM_TRANSACTION') {
          // 重连im
          $store.commit('set_imNeedReconnect', true)
        }
        // 请求后时间
        // let afterTime = new Date().getTime()
        // 同步服务端时间
        syncTime(res.headers)
        // 关闭loading遮罩
        // LeonLoading.install.close()
        if (+res.data.code === 10016) {   // 登录过期或者未登录
          signOut()
          /** 须 resolve + errorCallback，否则 await postNoLoading 永远不落盘，业务侧 .finally 不跑（如伴学 DIALOGUE_SEND 一直「等待回答」） */
          typeof errorCallback === 'function' && errorCallback(res.data)
          resolve(res)
        } else if (+res.data.code === 10200) {
          typeof callback === 'function' && callback(res.data)
        } else if (+res.data.code === 0) {
          typeof callback === 'function' && callback(res.data)
          resolve(res)
        } else if (+res.data.code === 10086) {
          return false
        } else if (+res.data.code === 45998) {
          if (routerInstance) {
            routerInstance.replace({
              path: '/accessFromActivity'
            })
          }
        } else if (+res.data.code === 45104 || +res.data.code === 45999 || +res.data.code === 41008 || +res.data.code === 40942 || res.data.code === 'A_0050' || res.data.code === 'A_0051' || res.data.code === 'A_0021' || res.data.code === 'A_0017' || +res.data.code === 45117 || res.data.code === 'A_0016' || +res.data.code === 45116) {
          // 前置任务未完成
          // A_0017  45117   --- 当前任务已结束
          // A_0016  45116   --- 当前任务未开始
          // A_0050  41008  40942  --- 没有报名
          // bol --- 当前是否是当前任务已结束或未开启
          let bol = res.data.code === 'A_0017' || res.data.code === 'A_0016'  || res.data.code === 'A_0050' || res.data.code === 'A_0051' || +res.data.code === 40942 || +res.data.code === 41008 || +res.data.code === 45116 || +res.data.code === 45117
          let taskTitle = ''
          if (bol && res.data.msg.indexOf) {
            let one = res.data.msg.indexOf('【')
            let two = res.data.msg.indexOf('】')
            if (one > -1 && two > -1) taskTitle = res.data.msg.slice(one + 1, two)
          }
          if (routerInstance) {
            routerInstance.replace({
              path: '/Predecessors',
              query: {
                taskTitle: !bol ? JSON.parse(res.data.msg).currentTaskTitle : taskTitle,
                taskRelationId: !bol ? JSON.parse(res.data.msg).taskRelationId : res.data.code
              }
            })
          }
          if (!bol && res.data.msg && JSON.parse(res.data.msg)) {
            sessionStorage.setItem(JSON.parse(res.data.msg).taskRelationId + 'taskRelationId', JSON.stringify({ requirementTask: res.data.msg }))
          }
        } else if (res.data.code === 'A_0013' || +res.data.code === 45118) {
          if (routerInstance) {
            routerInstance.replace({
              path: '/NoAuthorityPage'
            })
          }
        } else if ((+res.data.code === 56008 || +res.data.code === 56009 || +res.data.code === 56005 || +res.data.code === 56010) && constant !== 'TEST_PAPER_GET_PARPER' && constant !== 'TEST_PAPER_GET_TIME') {
          let path = ''
          let query = ''
          let currentQuery = getRouterQuery()
          if (+res.data.code === 56008) {
            // 迟到
            if (res.data.msg === '1') {
              // 考试
              path = '/ExamSystemMiss'
              query = {
                type: 3,
                examId: currentQuery.examId
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 3,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          } else if (+res.data.code === 56009) {
            // 考试终止
            if (res.data.msg === '1' || res.data.msg === '2') {
              // 考试
              path = '/ExamSystemMiss'
              query = {
                type: 2,
                examId: currentQuery.examId
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 2,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          } else if (+res.data.code === 56010) {
            // 不在名单
            path = '/ExamSystemMiss'
            query = {
              type: 1,
              examId: currentQuery.examId
            }
          } else if (+res.data.code === 56005) {
            // 考试已结束（正常参与考试的学生）
            if (res.data.msg === '1') {
              path = '/ExamSystemEnd'
              query = {
                examId: currentQuery.examId,
                taskRelationId: currentQuery.taskRelationId
              }
            } else if (res.data.msg === '2') {
              path = '/BattleList'
              query = {
                ...currentQuery
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 1,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          }
          if (routerInstance) {
            routerInstance.replace({
              path,
              query: { ...query }
            })
          }
        } else {
          typeof errorCallback === 'function' && errorCallback(res.data)
          // 判断是不是对战的错误码
          if (+res.data.code === 60000 ||
            +res.data.code === 60001 ||
            +res.data.code === 60002 ||
            +res.data.code === 60003 ||
            +res.data.code === 60004 ||
            +res.data.code === 60005 ||
            +res.data.code === 60006 ||
            +res.data.code === 60007 ||
            +res.data.code === 60008 ||
            +res.data.code === 60009 ||
            +res.data.code === 60010 ||
            +res.data.code === 61003 ||
            +res.data.code === 60018 ||
            +res.data.code === 60017 ||
            // 超级问答的错误码
            +res.data.code === 70013 ||
            +res.data.code === 70016 ||
            +res.data.code === 70014 ||
            +res.data.code === 70011 ||
            +res.data.code === 70012 ||
            +res.data.code === 70017 ||
            +res.data.code === 70024 ||
            +res.data.code === 56010 ||
            +res.data.code === 56009 ||
            +res.data.code === 56008 ||
            +res.data.code === 56005
          ) {
            // 不用错误提示
          } else {
            Message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        }
        if (constant !== 'USER_INFO') {
          // 过滤USER_INFO
          haveUserData(res.headers)
        }
      }).catch((error) => {
        // 关闭loading遮罩
        // LeonLoading.install.close()
        typeof catchCallback === 'function' && catchCallback(error)
        reject(error)
      })
    })
  }
  let axiosObj = await apiFn()
  return axiosObj
}

/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const post = async (constant, data = {}, callback, errorCallback, catchCallback) => {
  // 加载loading遮罩
  LeonLoading.install()
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  axios.defaults.headers.post['lang'] = localStorage.getItem('bloom:lang') && JSON.parse(localStorage.getItem('bloom:lang')) ? JSON.parse(localStorage.getItem('bloom:lang')).data === 'en' ? 'en_US' : 'zh_CN' : ''
  // 请求前时间
  // let beforeTime = new Date().getTime()
  // 兼容异步函数
  const apiFn = () => {
    return new Promise((resolve, reject) => {
      axios.post(
        url,
        JSON.stringify(data)
      ).then((res) => {
        // 请求后时间
        // let afterTime = new Date().getTime()
        // 同步服务端时间
        syncTime(res.headers)
        // 关闭loading遮罩
        LeonLoading.install.close()
        if (+res.data.code === 10016) {   // 登录过期或者未登录
          signOut()
          typeof errorCallback === 'function' && errorCallback(res.data)
          resolve(res)
        } else if (+res.data.code === 10200) {
          typeof callback === 'function' && callback(res.data)
        } else if (+res.data.code === 0) {
          typeof callback === 'function' && callback(res.data)
          resolve(res)
        } else if (+res.data.code === 10086) {
          return false
        } else if (+res.data.code === 45998) {
          if (routerInstance) {
            routerInstance.replace({
              path: '/accessFromActivity'
            })
          }
        } else if (res.data.code === 45101 || res.data.code === 'A_0012') {
          if (routerInstance) {
            routerInstance.replace({
              path: '/NoAuthorityPage'
            })
          }
        } else if (+res.data.code === 45104 || +res.data.code === 45999 || +res.data.code === 40942 || +res.data.code === 41008 || res.data.code === 'A_0050' || res.data.code === 'A_0051' || res.data.code === 'A_0021' || res.data.code === 'A_0017' || +res.data.code === 45117 || res.data.code === 'A_0016' || +res.data.code === 45116) {
          // 前置任务未完成
          // A_0017  45117   --- 当前任务已结束
          // A_0016  45116   --- 当前任务未开始
          // bol --- 当前是否是当前任务已结束或未开启
          console.log(res.data.code)
          let bol = res.data.code === 'A_0017' || res.data.code === 'A_0016' || res.data.code === 'A_0050' || res.data.code === 'A_0051' || +res.data.code === 40942 || +res.data.code === 41008 || +res.data.code === 45116 || +res.data.code === 45117
          let taskTitle = ''
          if (bol && res.data.msg.indexOf) {
            let one = res.data.msg.indexOf('【')
            let two = res.data.msg.indexOf('】')
            if (one > -1 && two > -1) taskTitle = res.data.msg.slice(one + 1, two)
          }
          if (routerInstance) {
            routerInstance.replace({
              path: '/Predecessors',
              query: {
                taskTitle: !bol ? JSON.parse(res.data.msg).currentTaskTitle : taskTitle,
                taskRelationId: !bol ? JSON.parse(res.data.msg).taskRelationId : res.data.code
              }
            })
          }
          if (!bol && res.data.msg && JSON.parse(res.data.msg)) {
            sessionStorage.setItem(JSON.parse(res.data.msg).taskRelationId + 'taskRelationId', JSON.stringify({ requirementTask: res.data.msg }))
          }
        } else if (res.data.code === 'A_0013' || +res.data.code === 45118) {
          if (routerInstance) {
            routerInstance.replace({
              path: '/NoAuthorityPage'
            })
          }
        } else if ((+res.data.code === 56008 || +res.data.code === 56009 || +res.data.code === 56005 || +res.data.code === 56010) && constant !== 'TEST_PAPER_GET_PARPER' && constant !== 'TEST_PAPER_GET_TIME') {
          let path = ''
          let query = ''
          let currentQuery = getRouterQuery()
          if (+res.data.code === 56008) {
            // 迟到
            if (res.data.msg === '1') {
              // 考试
              path = '/ExamSystemMiss'
              query = {
                type: 3,
                examId: currentQuery.examId
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 3,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          } else if (+res.data.code === 56009) {
            // 考试终止
            if (res.data.msg === '1' || res.data.msg === '2') {
              // 考试
              path = '/ExamSystemMiss'
              query = {
                type: 2,
                examId: currentQuery.examId
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 2,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          } else if (+res.data.code === 56010) {
            // 不在名单
            path = '/ExamSystemMiss'
            query = {
              type: 1,
              examId: currentQuery.examId
            }
          } else if (+res.data.code === 56005) {
            // 考试已结束（正常参与考试的学生）
            if (res.data.msg === '1') {
              path = '/ExamSystemEnd'
              query = {
                examId: currentQuery.examId,
                taskRelationId: currentQuery.taskRelationId
              }
            } else if (res.data.msg === '2') {
              path = '/BattleList'
              query = {
                ...currentQuery
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 1,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          }
          if (routerInstance) {
            routerInstance.replace({
              path,
              query: { ...query }
            })
          }
        } else {
          typeof errorCallback === 'function' && errorCallback(res.data)
          // 判断是不是对战的错误码
          if (+res.data.code === 60000 ||
            +res.data.code === 60001 ||
            +res.data.code === 60002 ||
            +res.data.code === 60003 ||
            +res.data.code === 60004 ||
            +res.data.code === 60005 ||
            +res.data.code === 60006 ||
            +res.data.code === 60007 ||
            +res.data.code === 60008 ||
            +res.data.code === 60009 ||
            +res.data.code === 60010 ||
            +res.data.code === 60018 ||
            +res.data.code === 60017 ||
            +res.data.code === 61003 ||
            +res.data.code === 70013 ||
            +res.data.code === 70016 ||
            +res.data.code === 70014 ||
            +res.data.code === 70012 ||
            +res.data.code === 70011 ||
            +res.data.code === 70017 ||
            +res.data.code === 70024 ||
            +res.data.code === 56010 ||
            +res.data.code === 56009 ||
            +res.data.code === 56008 ||
            +res.data.code === 56005
          ) {
            // 不用错误提示
          } else {
            Message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        }
        if (constant !== 'USER_INFO') {
          // 过滤USER_INFO
          haveUserData(res.headers)
        }
      }).catch((error) => {
        // 关闭loading遮罩
        LeonLoading.install.close()
        typeof catchCallback === 'function' && catchCallback(error)
        reject(error)
      })
    })
  }
  let axiosObj = await apiFn()
  return axiosObj
}

/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const testpost = async (constant, data = {}, callback, errorCallback, catchCallback) => {
  // 加载loading遮罩
  LeonLoading.install()
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  let url = constant
  url = '' + url
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  // 请求前时间
  // let beforeTime = new Date().getTime()
  // 兼容异步函数
  const apiFn = () => {
    return new Promise((resolve, reject) => {
      axios.post(
        url,
        JSON.stringify(data)
      ).then((res) => {
        // 请求后时间
        // let afterTime = new Date().getTime()
        // 同步服务端时间
        syncTime(res.headers)
        // 关闭loading遮罩
        LeonLoading.install.close()
        if (+res.data.code === 10016) {   // 登录过期或者未登录
          signOut()
        } else if (+res.data.code === 10200) {
          typeof callback === 'function' && callback(res.data)
        } else if (+res.data.code === 0) {
          typeof callback === 'function' && callback(res.data)
          resolve(res)
        } else if (+res.data.code === 10086) {
          return false
        } else if ((+res.data.code === 56008 || +res.data.code === 56009 || +res.data.code === 56005 || +res.data.code === 56010) && constant !== 'TEST_PAPER_GET_PARPER' && constant !== 'TEST_PAPER_GET_TIME') {
          let path = ''
          let query = ''
          let currentQuery = getRouterQuery()
          if (+res.data.code === 56008) {
            // 迟到
            if (res.data.msg === '1') {
              // 考试
              path = '/ExamSystemMiss'
              query = {
                type: 3,
                examId: currentQuery.examId
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 3,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          } else if (+res.data.code === 56009) {
            // 考试终止
            if (res.data.msg === '1' || res.data.msg === '2') {
              // 考试
              path = '/ExamSystemMiss'
              query = {
                type: 2,
                examId: currentQuery.examId
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 2,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          } else if (+res.data.code === 56010) {
            // 不在名单
            path = '/ExamSystemMiss'
            query = {
              type: 1,
              examId: currentQuery.examId
            }
          } else if (+res.data.code === 56005) {
            // 考试已结束（正常参与考试的学生）
            if (res.data.msg === '1') {
              path = '/ExamSystemEnd'
              query = {
                examId: currentQuery.examId,
                taskRelationId: currentQuery.taskRelationId
              }
            } else if (res.data.msg === '2') {
              path = '/BattleList'
              query = {
                ...currentQuery
              }
            } else if (res.data.msg === '3') {
              // SQ
              path = '/SuperQuizEndNew'
              query = {
                status: 1,
                examId: currentQuery.examId,
                returnUrl: currentQuery.fullPath ? currentQuery.fullPath : currentQuery.r
              }
            }
          }
          if (routerInstance) {
            routerInstance.replace({
              path,
              query: { ...query }
            })
          }
        } else {
          typeof errorCallback === 'function' && errorCallback(res.data)
          // 判断是不是对战的错误码
          if (+res.data.code === 60000 ||
            +res.data.code === 60001 ||
            +res.data.code === 60002 ||
            +res.data.code === 60003 ||
            +res.data.code === 60004 ||
            +res.data.code === 60005 ||
            +res.data.code === 60006 ||
            +res.data.code === 60007 ||
            +res.data.code === 60008 ||
            +res.data.code === 60009 ||
            +res.data.code === 60010 ||
            +res.data.code === 60018 ||
            +res.data.code === 60017 ||
            +res.data.code === 61003 ||
            +res.data.code === 70013 ||
            +res.data.code === 70016 ||
            +res.data.code === 70014 ||
            +res.data.code === 70012 ||
            +res.data.code === 70011 ||
            +res.data.code === 70017 ||
            +res.data.code === 70024 ||
            +res.data.code === 56010 ||
            +res.data.code === 56009 ||
            +res.data.code === 56008 ||
            +res.data.code === 56005
          ) {
            // 不用错误提示
          } else {
            Message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        }
        if (constant !== 'USER_INFO') {
          // 过滤USER_INFO
          haveUserData(res.headers)
        }
      }).catch((error) => {
        // 关闭loading遮罩
        LeonLoading.install.close()
        typeof catchCallback === 'function' && catchCallback(error)
        reject(error)
      })
    })
  }
  let axiosObj = await apiFn()
  return axiosObj
}

/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const purePost = async (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    // imConnectStatus等于1,且接口是TEST_INV_EXAM_TRANSACTION,则重连im
    if (res && res.data && res.data.data && +res.data.data.imConnectStatus === 1 && constant === 'TEST_INV_EXAM_TRANSACTION') {
      // 重连im
      $store.commit('set_imNeedReconnect', true)
    }
    haveUserData(res.headers)
    if (+res.data.code === 10016) {   // 登录过期或者未登录
      signOut()
    } else if (+res.data.code === 10200) {
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 10086) {
      return false
    } else if (+res.data.code === 45998) {
      if (routerInstance) {
        routerInstance.replace({
          path: '/accessFromActivity'
        })
      }
    } else if (+res.data.code === 45104 || +res.data.code === 45999 || +res.data.code === 40942 || +res.data.code === 41008 || res.data.code === 'A_0050' || res.data.code === 'A_0051'  || res.data.code === 'A_0021' || res.data.code === 'A_0017' || +res.data.code === 45117 || res.data.code === 'A_0016' || +res.data.code === 45116) {
      // 前置任务未完成
      // A_0017  45117   --- 当前任务已结束
      // A_0016  45116   --- 当前任务未开始
      // bol --- 当前是否是当前任务已结束或未开启
      let bol = res.data.code === 'A_0017' || res.data.code === 'A_0016' || res.data.code === 'A_0050' || res.data.code === 'A_0051' || +res.data.code === 40942 || +res.data.code === 41008 || +res.data.code === 45116 || +res.data.code === 45117
      let taskTitle = ''
      if (bol && res.data.msg.indexOf) {
        let one = res.data.msg.indexOf('【')
        let two = res.data.msg.indexOf('】')
        if (one > -1 && two > -1) taskTitle = res.data.msg.slice(one + 1, two)
      }
      if (routerInstance) {
        routerInstance.replace({
          path: '/Predecessors',
          query: {
            taskTitle: !bol ? JSON.parse(res.data.msg).currentTaskTitle : taskTitle,
            taskRelationId: !bol ? JSON.parse(res.data.msg).taskRelationId : res.data.code
          }
        })
      }
      if (!bol && res.data.msg && JSON.parse(res.data.msg)) {
        sessionStorage.setItem(JSON.parse(res.data.msg).taskRelationId + 'taskRelationId', JSON.stringify({ requirementTask: res.data.msg }))
      }
    } else if (res.data.code === 'A_0013' || +res.data.code === 45118) {
      if (routerInstance) {
        routerInstance.replace({
          path: '/NoAuthorityPage'
        })
      }
    } else {
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

export const logPost = async (data = {}, callback, errorCallback, catchCallback) => {
  let countNumObj = ''
  try {
    countNumObj = $utils.cache('bloom_call_num') && JSON.parse($utils.cache('bloom_call_num')) ? JSON.parse($utils.cache('bloom_call_num')) : ''
  } catch (error) {
    countNumObj = ''
  }
  if (countNumObj && countNumObj.callNum && countNumObj.curTime) {
    let countNum = countNumObj.callNum
    if ((new Date().getTime() - countNumObj.curTime) < 60000) {
      if (countNum > 50) {
        return
      } else {
        countNumObj.callNum = countNumObj.callNum + 1
        $utils.cache('bloom_call_num', JSON.stringify(countNumObj))
      }
    } else {
      countNumObj = { callNum: 1, curTime: new Date().getTime() }
      $utils.cache('bloom_call_num', JSON.stringify(countNumObj))
    }
  } else {
    countNumObj = { callNum: 1, curTime: new Date().getTime() }
    $utils.cache('bloom_call_num', JSON.stringify(countNumObj))
  }
  let url = apiConstant['REPROT_LOG_RECORD']
  url = '' + url
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  if (!data) {
    return
  }
  data.t = new Date().getTime()
  data.u = window.location.hash
  let obj = {
    cType: '4',
    lt: '1',
    logContent: data
  }
  axios.post(
    url,
    JSON.stringify(obj)
  ).catch((error) => {
    console.log(error)
  })
}

export const saveBehavior = async (data = {}, callback, errorCallback, catchCallback) => {
  try {
    let url = apiConstant['TEST_EXAM_TRANSACTION']
    url = '' + url
    axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
    axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
    axios.defaults.headers.post['ctype'] = 4
    if ($utils.sessionCache('appSrc')) {
      axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
    }
    if (!data) {
      return
    }
    axios.post(
      url,
      data
    ).catch((error) => {
      console.log(error)
    })
  } catch (error) {

  }
}

export const newSaveBehavior = async (data = {}, callback, errorCallback, catchCallback) => {
  try {
    let url = apiConstant['TEST_INV_EXAM_TRANSACTION']
    url = '' + url
    axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
    axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
    axios.defaults.headers.post['ctype'] = 4
    if ($utils.sessionCache('appSrc')) {
      axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
    }
    if (!data) {
      return
    }
    axios.post(
      url,
      data
    ).then(res => {
      if (res && res.data && res.data.data && +res.data.data.imConnectStatus === 1) {
        // 重连im
        $store.commit('set_imNeedReconnect', true)
      }
    }).catch((error) => {
      console.log(error)
    })
  } catch (error) {

  }
}

export const file = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = apiConstant[constant]
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
  axios.defaults.headers.post['lang'] = localStorage.getItem('bloom:lang') && JSON.parse(localStorage.getItem('bloom:lang')) ? JSON.parse(localStorage.getItem('bloom:lang')).data === 'en' ? 'en_US' : 'zh_CN' : ''
  axios.post(
    url,
    data
  ).then((res) => {
    if (+res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 10016) {
      signOut()
    } else if (+res.data.code === 10086) {
      return false
    } else {
      typeof errorCallback === 'function' && errorCallback(res.data)
      Message({
        showClose: true,
        message: res.data.msg,
        type: 'error'
      })
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

export const simplePost = (url, data = {}, callback, errorCallback, catchCallback) => {
  // 加载loading遮罩
  LeonLoading.install()
  url = '' + url
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    haveUserData(res.headers)
    // 关闭loading遮罩
    LeonLoading.install.close()
    if (+res.data.code === 10016) {   // 登录过期或者未登录
      signOut()
    } else if (+res.data.code === 10200) {
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 10086) {
      return false
    } else {
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    // 关闭loading遮罩
    LeonLoading.install.close()
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

export const pureGet = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = apiConstant[constant]
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  url = '' + url
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.get(
    url,
    // JSON.stringify(data)
    { params: data }
  ).then((res) => {
    haveUserData(res.headers)
    if (+res.data.code === 10016) {   // 登录过期或者未登录
      signOut()
    } else if (+res.data.code === 10200) {
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else {
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

export const getTxt = (api, callback, errorCallback) => {
  axios.get(api).then((res) => {
    // if (+res.data.code === 10016) {
    //   signOut()
    // }
    callback(res.data)
  }).catch((error) => {
    typeof errorCallback === 'function' && errorCallback(error)
  })
}

export const limitPost = (constant, data = {}, callback, errorCallback, catchCallback) => {
  // 加载loading遮罩
  LeonLoading.install()
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['effectiveType'] = $store.state.test.effectiveType
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    haveUserData(res.headers)
    // 关闭loading遮罩
    LeonLoading.install.close()

    if (+res.data.code === 10016) {   // 登录过期或者未登录
      // signOut()
      window.localStorage.removeItem('userData')
      $store.commit('set_isLogin', false)
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 10200) {
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else {
      typeof errorCallback === 'function' && errorCallback(res.data)
      Message({
        showClose: true,
        message: res.data.msg,
        type: 'error'
      })
    }
  }).catch((error) => {
    // 关闭loading遮罩
    LeonLoading.install.close()

    typeof catchCallback === 'function' && catchCallback(error)
  })
}

// 只需要异常提示的登录校验请求
export const limitPostNoLogin = (constant, data = {}, callback, errorCallback, catchCallback) => {
  // 加载loading遮罩
  if ($utils.sessionCache('appSrc')) {
    axios.defaults.headers.post['appSrc'] = $utils.sessionCache('appSrc')
  }
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    haveUserData(res.headers)
    // 关闭loading遮罩
    // LeonLoading.install.close()
    if (+res.data.code === 10016) {   // 登录过期或者未登录
      // signOut()
      window.localStorage.removeItem('userData')
      $store.commit('set_isLogin', false)
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 10200) {
      typeof callback === 'function' && callback(res.data)
    } else if (+res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else {
      typeof errorCallback === 'function' && errorCallback(res.data)
      Message({
        showClose: true,
        message: res.data.msg,
        type: 'error'
      })
    }
  }).catch((error) => {
    // 关闭loading遮罩
    LeonLoading.install.close()

    typeof catchCallback === 'function' && catchCallback(error)
  })
}



// WEBPACK FOOTER //
// ./src/assets/api/index.js